module.exports = __webpack_public_path__ + "e-learning-app/static/img/school4.3689327.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-course/img/ne/school4.png
// module id = AOrg
// module chunks = 1